// custom tag added to a Select that uses the tagRender function and allows for disabled select input options
// It uses Ant Design classes (ant-select-selection-item, ant-select-selection-item-content, ant-select-selection-item-remove) for styling
import * as React from "react"
import { Tooltip } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import "./SelectionItem.scss"

const SelectionItem = ({ label, type = "default", onClose, disabled, disabledTooltip, className }) => {
  const onPreventMouseDown = (event) => {
    // used on Ant Design documentation
    event.preventDefault()
    event.stopPropagation()
  }

  if (!label) return null

  if (disabled) {
    return (
      <Tooltip title={disabledTooltip}>
        <span
          title={label}
          onMouseDown={onPreventMouseDown}
          className={`ant-select-selection-item prime-select-selection-item prime-select-selection-item-disabled${` prime-select-selection-item-${type}`}${
            className ? ` ${className}` : ""
          }`}
        >
          <span className="ant-select-selection-item-content">{label}</span>
        </span>
      </Tooltip>
    )
  }

  return (
    <span
      title={label}
      onMouseDown={onPreventMouseDown}
      className={`ant-select-selection-item prime-select-selection-item${` prime-select-selection-item-${type}`}${
        className ? ` ${className}` : ""
      }`}
    >
      <span className="ant-select-selection-item-content">{label}</span>
      <span
        onClick={onClose}
        unselectable="on"
        aria-hidden="true"
        className="ant-select-selection-item-remove"
      >
        <CloseOutlined />
      </span>
    </span>
  )
}

SelectionItem.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf(["default", "request"]),
  onClose: PropTypes.func,
  disabled: PropTypes.bool,
  disabledTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
}

export default SelectionItem
